import { Component, ElementRef, ViewChild } from '@angular/core';
import { ValidatorFn, AbstractControl, ValidationErrors, FormArray, Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { Observable, startWith, map, forkJoin } from 'rxjs';
import { Country } from 'src/app/core/models/country.model';
import { kraPintype } from 'src/app/core/models/kRAPintype.model';
import { QuotationInfo } from 'src/app/core/models/quotations-info.model';
import { Quote } from 'src/app/core/models/quote.model';
import { Relationship } from 'src/app/core/models/relationship.model';
import { TravelPurpose } from 'src/app/core/models/travel-purpose.model';
import { Traveller } from 'src/app/core/models/traveller.model';
import { ErrorHandlerService } from 'src/app/core/services/error-handler.service';
import { LoaderService } from 'src/app/core/services/loader.service';
import { RestService } from 'src/app/core/services/rest.service';
import { NotificationComponent } from 'src/app/shared/components/notification/notification.component';
export function atLeastOneProposerValidator(): ValidatorFn {
  return (formArray: AbstractControl): ValidationErrors | null => {
    const isAtLeastOneSelected = (formArray as FormArray).controls
      .some(control => control.get('isProposerATraveller')?.value);

    return isAtLeastOneSelected ? null : { atLeastOneRequired: true };
  };
}
export function minAgeValidation(): ValidatorFn {
  return (formArray: AbstractControl): ValidationErrors | null => {
    const isAtLeastOneAboveOrEqual3 = (formArray as FormArray).controls
      .some(control => {
        const age = control.get('age')?.value;
        return age !== null && age >= 3;
      });

    return isAtLeastOneAboveOrEqual3 ? null : { minAgeRequired: true };
  };
}

export function oldAgeRestrictionValidation(): ValidatorFn {
  return (formArray: AbstractControl): ValidationErrors | null => {
    const isAnyOldAgePersion = (formArray as FormArray).controls
      .some(control => {
        const age = control.get('age')?.value;
        return age !== null && age > 80;
      });

    return isAnyOldAgePersion ? { oldAgeRestriction: true } : null;
  };
}

export function allSelectedValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    const formArray = control as FormArray;
    return formArray.controls.every(ctrl => ctrl.value === true) ? null : { notAllSelected: true };
  };
}
@Component({
  selector: 'app-proposal-form',
  templateUrl: './proposal-form.component.html',
  styleUrls: ['./proposal-form.component.scss']
})
export class ProposalFormComponent {
  submitted: boolean = false;
  filteredDestinations: Observable<Country[]> | undefined;
  selectedDestinations: Country[] = [];
  @ViewChild('destinationInput') destinationInput!: ElementRef<HTMLInputElement>;
  minTripEndDate: any;
  getTravelPurposeList: TravelPurpose[] = [];
  getCountriesList: Country[] = [];
  declarationList:any[]=[];
  consentList:any[]=[];
  allDeclarationsControl = new FormControl(false);
  allConsentsControl = new FormControl(false);
  proposalForm = this.fb.group({
    productName: [{ value: '', disabled: true }, Validators.required],
    premiumAmount: [{ value: '', disabled: true }, Validators.required],
    destination: [{ value: '', disabled: true }, Validators.required],
    tripStartDate: [{ value: '', disabled: true }, Validators.required],
    tripEndDate: [{ value: '', disabled: true }, Validators.required],
    travelingDays: [{ value: '', disabled: true }, Validators.required],
    numberOfTravelers: [{ value: '', disabled: true }, Validators.required],
    kraPinType: ['', Validators.required],
    kraPinNumber: [{ value: '', disabled: true }, [Validators.required, this.kraPinNumberValidator]],
    beneficiaryName: ['', Validators.required],
    beneficiaryTelephoneNo: ['', [Validators.required, Validators.minLength(9), Validators.maxLength(9)]],
    insuredOccupation: ['', Validators.required],
    // postalAddress: ['', Validators.required],
    address: this.fb.group({
      houseNumber: ['', Validators.required],
      roadName: ['', Validators.required],
      pincode: ['', Validators.required]
    }),
    travelersDetails: this.fb.array([], [atLeastOneProposerValidator(), minAgeValidation(),oldAgeRestrictionValidation()]),
    declarationInfo: this.fb.array([], allSelectedValidator()),
    consentInfo: this.fb.array([], allSelectedValidator())
  });

  dateOfBirthMaxDate = moment().subtract(1, 'years');
  quotationId: string = '';
  quotesId: string = '';
  selectedProduct!: Quote;
  quotesInfo!: QuotationInfo;
  travellerList: Traveller[] = [];
  selectedFile: File | null = null;
  countryCodes: any[] = [];
  relationshipList: Relationship[] = [];
  kRAPintypeList:kraPintype[]=[];
  selectedDeclarationsInEditMode:any[]=[];
  selectedConsentListInEditMode:any[]=[];
  constructor(
    private fb: FormBuilder,
    private restService: RestService,
    private loader: LoaderService,
    private router: Router,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private errorHandler: ErrorHandlerService,
  ) {
    this.route.params.subscribe(params => {
      this.quotationId = params['quotationId'];
      this.quotesId = params['quotesId'];
    });

    this.filteredDestinations = this.proposalForm.get("destination")?.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || ''))
    ) as Observable<Country[]>;
  }

  ngOnInit() {
    this.GetMasterData();
  }

  get getDeclarationInfo(): FormArray {
    return this.proposalForm.get('declarationInfo') as FormArray;
  }

  get  getConsentInfo(): FormArray {
      return this.proposalForm.get('consentInfo') as FormArray;
  }
  onFileSelected(event: Event, index: number): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFile = input.files[0];
      this.onUpload(index);
    } else {
      this.getTravelersDetails.at(index).get('passportFileAttachmentID')?.patchValue('');
    }
  }

  onUpload(index: number) {
    if (!this.selectedFile) {
      console.error('No file selected');
      return;
    }

    const formData = new FormData();
    formData.append('file', this.selectedFile, this.selectedFile.name);
    this.loader.show();
    this.restService.postData(formData, 'api/FileUpload/InsertPassport').subscribe(
      {
        next: (data: any) => {
          try {
            if (data.rcode == 200) {
              this.getTravelersDetails.at(index).get('passportFileAttachmentID')?.patchValue(data.rObj.AttachmentID);
            } else {
              this.errorHandler.handleRcodeError(data);
            }
          } catch (error) {
            this.errorHandler.internalError();
          } finally {
            this.loader.hide();
          }
        },
        error: (error: any) => {
          this.loader.hide();
          this.errorHandler.handleStatusError(error);
        }
      })
  }

  GetMasterData() {
    let getQuotesUserInfoParams = {
      QuotationID: this.quotationId,
      QuotesID: this.quotesId
    }
    const getMasterDataApiCall$ = this.restService.postData(null, 'api/Quotation/GetMasterData');
    const getQuotesUserInfoApiCall$ = this.restService.postData(getQuotesUserInfoParams, 'api/Quotation/UserInfo');
    this.loader.show();
    forkJoin([getMasterDataApiCall$, getQuotesUserInfoApiCall$]).subscribe(
      {
        next: ([masterData, userInfoData]) => {
          try {
            if (masterData.rcode == 200 && userInfoData.rcode == 200) {
              this.getTravelPurposeList = masterData.rObj.GetTravelPurpose || [];
              this.getCountriesList = masterData.rObj.GetCountries || [];
              this.relationshipList = masterData.rObj.Relationship || [];
              this.countryCodes = masterData.rObj.CountryCode || [];
              this.kRAPintypeList = masterData.rObj.kRAPintype || [];
              this.declarationList = masterData.rObj.declaration || [];
              this.consentList = masterData.rObj.consent || [];
              
              this.setupValueChanges();
              // this.GetQuotesUserInfo();

              this.quotesInfo = userInfoData.rObj.Quotations;
              this.selectedProduct = userInfoData.rObj.Quotes;
              this.travellerList = userInfoData.rObj.Traveller || [];
              let selectedDestinationsList = userInfoData.rObj.DestinationCountry || [];
              let selectedDestinationsIds = selectedDestinationsList.map((sdl: any) => sdl.DestinationCountryID);
              this.selectedDestinations = this.getCountriesList.filter(country => selectedDestinationsIds.includes(country.TocountryID));
              this.selectedDeclarationsInEditMode=userInfoData.rObj.declarations;
              this.selectedConsentListInEditMode=userInfoData.rObj.declarations;
              this.initializeDeclarationInfoControls();
              this.initializeConsentInfoControls();
              this.SetValuesToProposalForm();
              this.numberOfTravelers();
            } else if(masterData.rcode != 200){
              this.errorHandler.handleRcodeError(masterData);
            }else if(userInfoData.rcode != 200){
              this.errorHandler.handleRcodeError(userInfoData);
            }
          } catch (error) {
            this.errorHandler.internalError();
          } finally {
            this.loader.hide();
          }
        },
        error: (error: any) => {
          this.loader.hide();
          this.errorHandler.handleStatusError(error);
        }
      })
  }

  selectAllDeclarations(selectAll: boolean): void {
    const declarationInfo = this.proposalForm.get('declarationInfo') as FormArray;
    declarationInfo.controls.forEach(control => control.setValue(selectAll));
    this.updateAllDeclarationsSelected();
  }
  
  selectAllConsents(selectAll: boolean): void {
    const consentInfo = this.proposalForm.get('consentInfo') as FormArray;
    consentInfo.controls.forEach(control => control.setValue(selectAll));
    this.updateAllConsentsSelected();
  }
 

  updateAllDeclarationsSelected(): void {
    const allSelected = this.getDeclarationInfo.controls.every(control => control.value);
    if (this.allDeclarationsControl.value !== allSelected) {
      this.allDeclarationsControl.setValue(allSelected, { emitEvent: false });
    }
  }

  updateAllConsentsSelected(): void {
    const allSelected = this.getConsentInfo.controls.every(control => control.value);
    if (this.allConsentsControl.value !== allSelected) {
      this.allConsentsControl.setValue(allSelected, { emitEvent: false });
    }
  }
  
  setupValueChanges(): void {
    this.proposalForm.get('kraPinType')?.valueChanges.subscribe(value => {
      const kraPinNumberControl = this.proposalForm.get('kraPinNumber');
      if (value) {
        kraPinNumberControl?.enable();
      } else {
        kraPinNumberControl?.disable();
      }
    });

    this.proposalForm.get('kraPinNumber')?.valueChanges.subscribe(value => {
      if (value) {
        this.proposalForm.get('kraPinNumber')?.setValue(value.toUpperCase(), { emitEvent: false });
      }
    });
  }

  kraPinNumberValidator(control: AbstractControl): { [key: string]: boolean } | null {
    const value = control.value;
    if(!value){
      return null;
    }
    if (value && value.length === 11 && /^[A-Z]\d{9}[A-Z]$/.test(value)) {
      return null;
    }
    return { invalidKraPinNumber: true };
  }

  initializeDeclarationInfoControls(): void {
    const declarationInfo = this.proposalForm.get('declarationInfo') as FormArray;
    this.declarationList.forEach((declaration) => {
      const exists = this.selectedDeclarationsInEditMode.some(item => item.declarationid == declaration.masterDataID);
      declarationInfo.push(new FormControl(exists))
    }
    );
    this.updateAllDeclarationsSelected();
  }

  initializeConsentInfoControls(): void {
    const consentInfo = this.proposalForm.get('consentInfo') as FormArray;
    this.consentList.forEach((consent) =>{
      const exists = this.selectedConsentListInEditMode.some(item => item.declarationid == consent.masterDataID);
      consentInfo.push(new FormControl(exists))
    });
    this.updateAllConsentsSelected();
  }

  GetQuotesUserInfo() {
    let params = {
      QuotationID: this.quotationId,
      QuotesID: this.quotesId
    }
    this.loader.show();
    this.restService.postData(params, 'api/Quotation/UserInfo').subscribe(
      {
        next: (data: any) => {
          try {
            if (data.rcode == 200) {
              this.quotesInfo = data.rObj.Quotations;
              this.selectedProduct = data.rObj.Quotes;
              this.travellerList = data.rObj.Traveller || [];
              let selectedDestinationsList = data.rObj.DestinationCountry || [];
              let selectedDestinationsIds = selectedDestinationsList.map((sdl: any) => sdl.DestinationCountryID);
              this.selectedDestinations = this.getCountriesList.filter(country => selectedDestinationsIds.includes(country.TocountryID));
              this.SetValuesToProposalForm();
              this.numberOfTravelers();
            } else {
              this.errorHandler.handleRcodeError(data);
            }
          } catch (error) {
            this.errorHandler.internalError();
          } finally {
            this.loader.hide();
          }
        },
        error: (error: any) => {
          this.loader.hide();
          this.errorHandler.handleStatusError(error);
        }
      })
  }

  SetValuesToProposalForm() {
    this.proposalForm.patchValue({
      productName: this.selectedProduct.ProductName,
      premiumAmount: this.selectedProduct.sTotalAmount,
      tripStartDate: this.quotesInfo.FromDate,
      tripEndDate: this.quotesInfo.ToDate,
      travelingDays: this.quotesInfo.NoofDays.toString(),
      numberOfTravelers: this.quotesInfo.NoofTravellers.toString(),
      kraPinType: this.quotesInfo.KRAPinTypeID=='00000000-0000-0000-0000-000000000000'?null:this.quotesInfo.KRAPinTypeID,
      kraPinNumber: this.quotesInfo.KRAPinNumber,
      insuredOccupation: this.quotesInfo.Occupation,
      beneficiaryName: this.quotesInfo.BeneficiaryName,
      beneficiaryTelephoneNo: this.quotesInfo.BeneficiaryPhoneNumber,
      address: {
        houseNumber: this.quotesInfo.AddressLine1,
        roadName: this.quotesInfo.AddressLine2,
        pincode: this.quotesInfo.AddressLine3
      }
    })
  }

  numberOnly(event: any) {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  newTravelersDetaile(traveller: Traveller): FormGroup {
    return this.fb.group({
      isProposerATraveller: [{ value: traveller.IsPolicyHolder, disabled: true }, Validators.required],
      // title: [''],
      firstName: [traveller.FirstName, Validators.required],
      lastName: [traveller.LastName, Validators.required],
      nameAsPerThePassport: [traveller.Fullname, Validators.required],
      dateOfBirth: [traveller.DOB, Validators.required],
      age: [{ value: traveller.Age, disabled: true }, Validators.required],
      mobileCode: [this.countryCodes.length == 1 ? this.countryCodes[0].masterDataID : traveller.PhoneNumberCountryCode, Validators.required],
      mobileNumber: [traveller.sPhoneNumber, [Validators.required, Validators.minLength(9), Validators.maxLength(9)]],
      emailId: [traveller.EmailId, [Validators.required, Validators.email]],
      passportNumber: [traveller.PolicyHolderPassPortNumber, Validators.required],
      relationshipWithTheProposer: [{
        value: traveller.IsPolicyHolder ? 'eaf41d97-4dd2-4406-b351-5424e55507b2' :
          traveller.RelationshipTypeID == '00000000-0000-0000-0000-000000000000' ? null : traveller.RelationshipTypeID
        , disabled: traveller.IsPolicyHolder
      }, Validators.required],
      passportFile: [null],
      passportFileAttachmentID: [
        traveller.PassportAttachmentID == '00000000-0000-0000-0000-000000000000' ? null : traveller.PassportAttachmentID, Validators.required]
    })

  }

  onProposerChange(selectedGroup: any, selected: boolean) {
    if (selected) {
      this.disableOtherProposerControls(selectedGroup);
    } else {
      this.enableAllProposerControls();
    }
    this.getTravelersDetails.updateValueAndValidity();
  }

  disableOtherProposerControls(selectedGroup: FormGroup) {
    this.getTravelersDetails.controls.forEach(group => {
      if (group !== selectedGroup) {
        group.get('isProposerATraveller')?.disable();
      }
    });
  }

  disableOtherProposerControlsOnPatchValue() {
    this.getTravelersDetails.controls.forEach(group => {
      if (!group.get('isProposerATraveller')?.value) {
        group.get('isProposerATraveller')?.disable();
      }
    });
  }

  enableAllProposerControls() {
    this.getTravelersDetails.controls.forEach(group => {
      group.get('isProposerATraveller')?.enable();
    });
  }

  get getTravelersDetails(): FormArray {
    return this.proposalForm.get("travelersDetails") as FormArray;
  }

  numberOfTravelers(): void {
    this.getTravelersDetails.clear();
    for (const traveller of this.travellerList) {
      this.getTravelersDetails.push(this.newTravelersDetaile(traveller));
    }
    this.disableOtherProposerControlsOnPatchValue();
  }

  removeTravelersDetaile(i: number) {
    this.getTravelersDetails.removeAt(i);
  }

  remove(destination: Country): void {
    const index = this.selectedDestinations.indexOf(destination);
    if (index >= 0) {
      this.selectedDestinations.splice(index, 1);
      this.onFocus();
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    const selectedCountry = this.getCountriesList.find(country => country.TocountryID === event.option.value);
    if (selectedCountry) {
      this.selectedDestinations.push(selectedCountry);
      this.destinationInput.nativeElement.value = '';
      this.proposalForm.get('destination')?.patchValue('');
      this.onFocus();
    }
  }

  private _filter(value: string): Country[] {
    const filterValue = value.toLowerCase();
    return this.getCountriesList.filter(country =>
      country.ToCountryName.toLowerCase().includes(filterValue) &&
      !this.selectedDestinations.some(selected => selected.TocountryID === country.TocountryID)
    );
  }

  onFocus() {
    this.filteredDestinations = this.proposalForm.get("destination")?.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || ''))
    ) as Observable<Country[]>;
  }

  calculateAge(dob: Date): number {
    const today = new Date();
    const birthDate = new Date(dob);
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }

  dateOfBirthChange(event: MatDatepickerInputEvent<Date>, index: number) {
    let dob = this.getTravelersDetails.at(index).get('dateOfBirth')?.value;
    let getAge = this.calculateAge(dob);
    this.getTravelersDetails.at(index).get('age')?.patchValue(getAge);
  }

  submit() {
    this.submitted = true;
    if (this.proposalForm.invalid) {
      return;
    }

    let _dialogRef = this.dialog.open(NotificationComponent, {
      disableClose: true,
      panelClass: 'dialog-class',
      data: {
        block: 'notificationYesOrNO',
        message: 'Are you sure you want to submit the Proposal?',
      }
    });

    _dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.UserProposal();
      }
    });


  }

  UserProposal() {
    
    const selectedDeclarations = this.proposalForm.get('declarationInfo')?.value
    .map((checked, index) => checked ? { DeclarationId: this.declarationList[index].masterDataID } : null)
    .filter(value => value !== null);

    const selectedConsents = this.proposalForm.get('consentInfo')?.value
    .map((checked, index) => checked ? { ConsentId: this.consentList[index].masterDataID } : null)
    .filter(value => value !== null);

    let travelersDetails = this.proposalForm.get('travelersDetails')?.getRawValue() || [];
    const addressGroup = this.proposalForm.get('address') as FormGroup;
    let params = {
      QuotationID: this.quotationId,
      QuotesID: this.selectedProduct.QuotesID,
      ProductName: this.proposalForm.get("productName")?.value,
      ProductID: this.selectedProduct.ProductID,
      ProductSourceID: this.selectedProduct.ProductSourceID,
      TotalAmount: this.selectedProduct.TotalAmount,
      ToCountriesId: this.selectedDestinations.map(({ ToCountrySourceId, TocountryID, ToCountryName, ToCountryCode }) => ({
        CountrySourceId: ToCountrySourceId,
        CountryId: TocountryID,
        CountryName: ToCountryName,
        CountryCode: ToCountryCode
      })),
      AddressLine1: addressGroup.get('houseNumber')?.value,
      AddressLine2: addressGroup.get('roadName')?.value,
      AddressLine3: addressGroup.get('pincode')?.value,
      AddressLine4: "",
      AddressLine5: "",
      FromDate: moment(this.proposalForm.get("tripStartDate")?.value).format('YYYY-MM-DD'),
      ToDate: moment(this.proposalForm.get("tripEndDate")?.value).format('YYYY-MM-DD'),
      NoofDays: parseInt(this.proposalForm.get("travelingDays")?.value || '', 10),
      NoofTravellers: parseInt(this.proposalForm.get("numberOfTravelers")?.value || '', 10),
      TravellersInformation: travelersDetails.map((td: any) => {
        let selectedRelationship: Relationship = this.relationshipList.find(relationship => relationship.masterDataID == td.relationshipWithTheProposer) as Relationship;
        return {
          FirstName: td.firstName,
          LastName: td.lastName,
          FullName: td.nameAsPerThePassport,
          DOB: td.dateOfBirth ? moment(td.dateOfBirth).format('YYYY-MM-DD') : null,
          Age: td.age ? parseInt(td.age, 10) : null,
          // CountryCode: td.mobileCode,
          CountryCode: 254,
          MobileNumber: parseInt(td.mobileNumber, 10),
          Email: td.emailId,
          PassportNumber: td.passportNumber,
          RelationshipID: td.relationshipWithTheProposer,
          Relationship: selectedRelationship?.mdTitle,
          PassportID: td.passportFileAttachmentID || null,
          IsPolicyHolder: td.isProposerATraveller,
        }
      }),
      KRAPinTypeID:this.proposalForm.get("kraPinType")?.value,
      KRAPinNumber:this.proposalForm.get("kraPinNumber")?.value,
      Occupation:this.proposalForm.get("insuredOccupation")?.value,
      Postaladdress:null,
      DeclarationInfo:selectedDeclarations,
      ConsentInfo:selectedConsents,
      BeneficiaryName:this.proposalForm.get("beneficiaryName")?.value,
      BeneficiaryPhoneNumber:this.proposalForm.get("beneficiaryTelephoneNo")?.value
    }
    this.loader.show();
    this.restService.postData(params, 'api/Quotation/UserProposal').subscribe(
      {
        next: (data: any) => {
          try {
            if (data.rcode == 200) {
              this.router.navigate(['policy/payment-form', this.quotationId, this.quotesId]);
            } 
            else if (data.rcode == 504) {
              this.errorHandler.hasOverlappingPassportDatesError(data);
            } 
            else {
              this.errorHandler.handleRcodeError(data);
            }
          } catch (error) {
            this.errorHandler.internalError();
          } finally {
            this.loader.hide();
          }
        },
        error: (error: any) => {
          this.loader.hide();
          this.errorHandler.handleStatusError(error);
        }
      });
  }

  goBack() {
    this.router.navigate(['quotation/quotation-premium', this.quotationId]);
  }

  DownloadPassportCopy(index: number) {
    let attachmentID = this.getTravelersDetails.at(index).get('passportFileAttachmentID')?.value
    let params = {
      AttachmentID: attachmentID
    }
    this.loader.show();
    this.restService.postData(params, 'api/Download/DownloadUserProfile').subscribe(
      {
        next: (data: any) => {
          try {
            if (data.rcode == 200) {
              if (data.rObj.URL) {
                window.open(data.rObj.URL, '_target');
              }
            } else {
              this.errorHandler.handleRcodeError(data);
            }
          } catch (error) {
            this.errorHandler.internalError();
          } finally {
            this.loader.hide();
          }
        },
        error: (error: any) => {
          this.loader.hide();
          this.errorHandler.handleStatusError(error);
        }
      })
  }
}
